import React, { useState, useEffect } from "react";
import MenuButtons from "../../components/MenuButtons";
import { Link } from "react-router-dom";
import { useAuth } from "../../services/AuthContext";
import { fetchChildSavingsInfo } from "../../services/Api";
import LoadingSpinner from "../../components/LoadingSpinner";

const lessons = [
  { id: "0iRbD5rM5qc", title: "Financial Literacy" },
  { id: "ScXAyGh0MRg", title: "Checking and Savings Accounts" },
  { id: "iSmNwXbNhgQ", title: "Debit and Credit" },
  { id: "c9VFbAJRSv0", title: "Borrowing vs. Saving" },
  { id: "aRcXutXvfmM", title: "Needs and Wants" },
  { id: "cYGiipJOiLg", title: "Making a Budget" },
  { id: "t0HjVmgNGE4", title: "Calculating Interest" },
  { id: "RCSWEzr0H6o", title: "Calculating Sales Tax" },
];

const LessonsPage = () => {
  const { childID } = useAuth();
  const [firstName, setFirstName] = useState("");
  const [isSpinnerLoading, setIsSpinnerLoading] = useState(true);
  

  useEffect(() => {
    setIsSpinnerLoading(true);
    const fetchData = async () => {
      try {
        const minDelay = new Promise(resolve => setTimeout(resolve, 200));
        const [savingsRes] = await Promise.all([
          fetchChildSavingsInfo(childID),
          minDelay
        ]);
        setFirstName(savingsRes?.childInfo.firstName);
      } catch (error) {        
        console.error('Error fetching data:', error);
      } finally {
        setIsSpinnerLoading(false);
      }
    }

    fetchData()
  }, [childID]);

  return (
    <>
      <MenuButtons />
      <LoadingSpinner isLoading={isSpinnerLoading}/>
      {/* add a div fade-in and conditional visible classes to get fade in for content working*/}
      <div className={`fade-in ${!isSpinnerLoading ? "visible" : ""}`}>
        <div className="centerlessons">
          <div className="gridlessons">
            {lessons.map((lesson) => (
              <Link key={lesson.id} to={`/lessons/video/${lesson.id}`}>
                <img
                  src={`https://img.youtube.com/vi/${lesson.id}/hqdefault.jpg`}
                  loading="lazy"
                  alt={lesson.title}
                  className="lessonicon"
                  srcSet={`
                    https://img.youtube.com/vi/${lesson.id}/mqdefault.jpg 320w,
                    https://img.youtube.com/vi/${lesson.id}/hqdefault.jpg 480w,
                    https://img.youtube.com/vi/${lesson.id}/hqdefault.jpg 640w
                  `}
                  sizes="(max-width: 767px) 80vw, (max-width: 991px) 50vw, 35vw"
                  style={{
                    maxWidth: "420px",
                    width: "35vw",
                    height: "auto",
                    objectFit: "cover",
                    aspectRatio: "16 / 9",
                    borderRadius: "10px",
                  }}
                />
              </Link>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default LessonsPage;
